import { PropsWithChildren, ReactNode } from 'react';
import { Container, SxProps, Theme } from '@mui/material';
import Grid from '@mui/material/Grid2';
import {
  Description,
  pageContainerStyles,
  pageGridDescriptionStyles,
  pageGridTitleStyles,
  pageTitleStyles,
  Title
} from './styles';

type PageProps = {
  title: string;
  titleSx?: SxProps<Theme>;
  description?: ReactNode;
};

export const Page = ({ title, description, titleSx, children }: PropsWithChildren<PageProps>) => {
  return (
    <Container sx={pageContainerStyles}>
      <Grid container direction="column">
        <Grid sx={pageGridTitleStyles}>
          <Title
            variant="h3"
            data-testid="page-heading"
            sx={{ ...pageTitleStyles, ...titleSx } as SxProps<Theme>}>
            {title}
          </Title>
        </Grid>
        {description && (
          <Grid sx={pageGridDescriptionStyles}>
            <Description>{description}</Description>
          </Grid>
        )}
        <Grid>{children}</Grid>
      </Grid>
    </Container>
  );
};
